module.exports = __webpack_public_path__ + "img/chat_bot_1.a9b99efb.webp";